import { Text } from "@mantine/core";
import { CSSProperties } from "react";
import classes from "./render-text.module.css";

interface RenderTextProps {
  text: string | number;
  isAmount?: boolean;
  color?: string;
  fontWeight?: number;
  style?: CSSProperties;
  useHover?: boolean;
}

const RenderText = ({ text, isAmount = false, color = "#444", fontWeight = 500, style = {}, useHover = false }: RenderTextProps) => {
  return (
    <Text
      size="sm"
      fw={fontWeight}
      c={color}
      ta={isAmount ? "end" : undefined}
      w={isAmount ? undefined : "max-content"}
      style={{ whiteSpace: isAmount ? "nowrap" : undefined, ...style }}
      className={useHover ? classes.text : ""}>
      {text}
    </Text>
  );
};

export default RenderText;
